
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.88,"time":52800,"words":176}
/* @jsx mdx */
import TileVp from '../../overlays/TileVp';
import EstateService from '../../overlays/EstateService';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The Barn is the service location that references the employment of a head gardener and empowers the family to enhance their reputation when estate activities are hosted.`}</p>
    <p><img parentName="p" {...{
        "src": "./barn.png"
      }}></img></p>
    <div className="flavor-text">
      <p>{`Few aesthetic pursuits more iconically represent 19th century English culture than the enjoyment of gardens and manicured grounds. A serious investment in the beloved grounds of the family’s estate would draw notice and praise, and enhance the family’s reputation in the area.`}</p>
    </div>
    <p>{`The Barn service tile appears randomly in the builders’ market and has a discount of £100 attached to the purchase price. When a player acquires this tile, it is placed under SERVICE in the country estate organiser.`}</p>
    <EstateService mdxType="EstateService" />
    <p>{`On all future turns when an estate tile is played, the player increases his reputation by one on his player board reputation wheel.`}</p>
    <p>{`Note that the Barn is worth 2 victory points; all other service tiles are worth at most 1 victory point.`}</p>
    <TileVp src="barn.png" mdxType="TileVp" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Barn",
  "vp": 2,
  "category": "service",
  "surcharge": -100
}

